/**
 * `<input type="datetime-local">` 표시값 ↔ BE Instant(ISO-8601 'Z') 변환.
 *
 * catalog ID39(detailMapper) 와 동일 시맨틱 — datetime-local 은 초/타임존이 없는
 * 'YYYY-MM-DDTHH:mm' 을, 비울 때는 '' 을 낸다. BE 는 Instant 라 'Z'/offset 이 없으면
 * Jackson 파싱이 실패하므로, 전송 직전에 `new Date(...).toISOString()` 으로 정규화한다.
 */

/** datetime-local('YYYY-MM-DDTHH:mm') / 풀 ISO / '' → Instant('...Z') | null. 빈/파싱불가 → null. */
export const localInputToInstant = (v: string | null | undefined): string | null => {
  if (v == null || v === '') return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

/** BE Instant('...Z') → datetime-local 표시값('YYYY-MM-DDTHH:mm', 로컬시각). 빈/파싱불가 → ''. */
export const instantToLocalInput = (v: string | null | undefined): string => {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/**
 * 15-D-3(ID86) 종료 시각이 시작 시각보다 빠른지 — **둘 다 지정**(non-null Instant)일 때만 판정.
 * 한쪽만/둘 다 미지정(null)은 false(검증 통과 = 시각 미지정 허용). BE 가드(둘 다 지정 시 거부)의 BO 1차 미러.
 */
export const isEndBeforeStart = (
  startAt: string | null | undefined,
  endAt: string | null | undefined,
): boolean => {
  if (!startAt || !endAt) return false;
  const s = new Date(startAt).getTime();
  const e = new Date(endAt).getTime();
  if (Number.isNaN(s) || Number.isNaN(e)) return false;
  return e < s;
};
